import React from 'react'
import Header from '../../component/Header'
import CertificateinHealthcareInformatics from '../CertificateinHealthcareInformatics'
import Footer from '../../component/Footer'

export default function LayoutCertificateinHealthcareInformatics() {
    return (
        <div>
            <Header />
            <CertificateinHealthcareInformatics />
            <Footer />
        </div>
    )
}
